<div class="keylesson-detail-container" *ngIf="!playMode">
  <h1 fxLayout="row" fxLayoutAlign="center center" class="dark-gray">
    {{ 'KEYLESSON.DETAIL.TITLE' | translate: {value: lesson.id} }}
  </h1>

  <div fxLayout="row">

    <div fxFlex="50" class="lesson-info-container">

      <div class="lesson-info">
        <label>{{ 'KEYLESSON.DETAIL.LAST.ACCESS' | translate }}</label>
        <strong><span>{{ !!lesson.lastAccess ? lesson.lastAccess : '-' }}</span></strong>
      </div>

      <div class="lesson-info">
        <label>{{ 'KEYLESSON.DETAIL.KEY.LETTERS' | translate }}</label>
        <strong><span>{{lessonLetters}}</span></strong>
      </div>

      <div class="lesson-info">
        <label>{{ 'KEYLESSON.DETAIL.LAST.EXERCISE' | translate }}</label>
        <strong><span>{{ !!lesson.bestExercise ? lesson.bestExercise : '0'}}/{{lesson.exercises.length}}</span></strong>
      </div>

    </div>

    <!-- video -->
    <div fxFlex="50">
      <video class="video" controls autoplay>
        <source [src]="lessonVideoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>      
    </div>

  </div>

  <div class="buttons-container">
    <div class="main-button" (click)="continue()">{{ 'KEYLESSON.DETAIL.CONTINUE' | translate }}</div>

    <div class="secondary-button" (click)="reset()">{{ 'KEYLESSON.DETAIL.RESTART' | translate }}</div>

    <div class="secondary-button" (click)="goBack()">{{ 'KEYLESSON.DETAIL.CANCEL' | translate }}</div>
  </div>

</div>

<!-- play mode -->
<router-outlet 
  (activate)="playMode=true"
  (deactivate)="onDeactivateChild()">
</router-outlet>
